import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  dealerAccess,
  updateDealerAccess,
} from "../../redux/actions/orderActions";
import { fetchDealers } from "../../redux/actions/authActions";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaChevronDown } from "react-icons/fa";

const PERMISSIONS = [
  { key: "is_read", label: "View" },
  { key: "is_create", label: "Create" },
  { key: "is_update", label: "Update" },
  { key: "is_delete", label: "Delete" },
];

// const CheckBox = ({ checked, onChange }) => (
//   <div
//     onClick={onChange}
//     className={`w-5 h-5 mx-auto flex-shrink-0 rounded border-2 flex items-center justify-center cursor-pointer transition-colors duration-150
//       ${checked ? "bg-amber-500 border-amber-500" : "bg-white border-gray-300 hover:border-amber-400"}`}
//   >
//     {checked && (
//       <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
//       </svg>
//     )}
//   </div>
// );

const CheckBox = ({ checked, onChange, disabled }) => (
  <div
    onClick={!disabled ? onChange : undefined}
    className={`w-5 h-5 mx-auto flex-shrink-0 rounded border-2 flex items-center justify-center transition-colors duration-150
      ${
        disabled
          ? "bg-amber-500 border-amber-500 cursor-not-allowed opacity-70"
          : checked
            ? "bg-amber-500 border-amber-500 cursor-pointer"
            : "bg-white border-gray-300 hover:border-amber-400 cursor-pointer"
      }`}
  >
    {checked && (
      <svg
        className="w-3 h-3 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={3}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    )}
  </div>
);
const DealerAccessList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);
  const { dealers } = useSelector((state) => state.dealerList);
  const {
    loading,
    access_modules,
    error,
    updateLoading,
    updateSuccess,
    updateError,
  } = useSelector((state) => state.dealerAccess);

  const [selectedDealerId, setSelectedDealerId] = useState("");
  const [modulePerms, setModulePerms] = useState({});

  // Fetch dealer list on mount
  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(fetchDealers(userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token]);

  // Initialize permissions from API response using access_module_id
  // useEffect(() => {
  //   const modules = access_modules?.data || [];
  //   if (modules.length > 0) {
  //     const initial = {};
  //     modules.forEach((m) => {
  //       initial[m.access_module_id] = {
  //         enabled: !!(m.is_read || m.is_create || m.is_update || m.is_delete),
  //         is_read:   !!m.is_read,
  //         is_create: !!m.is_create,
  //         is_update: !!m.is_update,
  //         is_delete: !!m.is_delete,
  //       };
  //     });
  //     setModulePerms(initial);
  //   }
  // }, [access_modules]);
  // Initialize permissions from API response using access_module_id
  // Default all to true — user can uncheck what they don't want
  useEffect(() => {
    const modules = access_modules?.data || [];
    if (modules.length > 0) {
      const dealerHasAnySavedPerms = modules.some(
        (m) => m.is_read || m.is_create || m.is_update || m.is_delete,
      );

      const initial = {};
      modules.forEach((m) => {
        // Module 10 is always fully enabled and cannot be changed
        if (m.access_module_id === 10) {
          initial[m.access_module_id] = {
            enabled: true,
            is_read: true,
            is_create: true,
            is_update: true,
            is_delete: true,
          };
          return;
        }

        initial[m.access_module_id] = {
          enabled: dealerHasAnySavedPerms
            ? !!(m.is_read || m.is_create || m.is_update || m.is_delete)
            : true,
          is_read: dealerHasAnySavedPerms ? !!m.is_read : true,
          is_create: dealerHasAnySavedPerms ? !!m.is_create : true,
          is_update: dealerHasAnySavedPerms ? !!m.is_update : true,
          is_delete: dealerHasAnySavedPerms ? !!m.is_delete : true,
        };
      });
      setModulePerms(initial);
    }
  }, [access_modules]);

  const handleDealerChange = (e) => {
    const userId = e.target.value;
    setSelectedDealerId(userId);
    setModulePerms({});
    if (userId && userInfo?.access_token) {
      dispatch(dealerAccess(userInfo.access_token, userId));
    }
  };

  const handlePermToggle = (moduleId, permKey) => {
    setModulePerms((prev) => {
      const current = prev[moduleId];
      if (!current) return prev;
      const updated = { ...current, [permKey]: !current[permKey] };
      const anyTrue = PERMISSIONS.some(({ key }) => updated[key]);
      return {
        ...prev,
        [moduleId]: { ...updated, enabled: anyTrue },
      };
    });
  };

  const handleSave = async () => {
    if (!selectedDealerId) {
      alert("Please select a dealer first.");
      return;
    }
    const modules = access_modules?.data || [];
    const permissions = modules.map((m) => {
      const perms = modulePerms[m.access_module_id];
      return {
        access_module_id: m.access_module_id,
        is_read: !!perms?.is_read,
        is_create: !!perms?.is_create,
        is_update: !!perms?.is_update,
        is_delete: !!perms?.is_delete,
      };
    });
    await dispatch(
      updateDealerAccess(userInfo.access_token, selectedDealerId, permissions),
    );
  };

  const dealerArray = Array.isArray(dealers)
    ? dealers
    : dealers
      ? [dealers]
      : [];
  const selectedDealer = dealerArray.find(
    (d) => d.user_id === selectedDealerId,
  );
  const modules = access_modules?.data || [];

  if (error) {
    const msg =
      typeof error === "object" && error !== null
        ? error.message || JSON.stringify(error)
        : error;
    return (
      <DashboardLayout>
        <div className="mt-2 max-w-full mx-auto rounded-lg p-4">
          <p className="text-red-600 font-bold text-center">Error: {msg}</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mt-2 max-w-full mx-auto rounded-lg p-4">
        {/* Header */}
        <div className="flex items-center space-x-3 mb-6">
          <button onClick={() => navigate(-1)} className="hover:text-gray-800">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-amber-600">Access Modules</h2>
        </div>

        {/* Dealer Selector */}
        <div className="mb-6 max-w-sm">
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Select Dealer <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <select
              value={selectedDealerId}
              onChange={handleDealerChange}
              className="w-full appearance-none px-4 py-2.5 pr-10 border border-gray-400 rounded-lg text-sm bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400"
            >
              <option value="">-- Select a Dealer --</option>
              {dealerArray.map((dealer) => (
                <option key={dealer.user_id} value={dealer.user_id}>
                  {dealer.firm_name}
                  {dealer.name ? ` — ${dealer.name}` : ""}
                  {dealer.mobile ? ` (${dealer.mobile})` : ""}
                </option>
              ))}
            </select>
            <FaChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <p className="font-bold text-md text-center text-gray-500 py-10">
            Loading...
          </p>
        )}

        {/* Prompt to select dealer */}
        {!loading && !selectedDealerId && (
          <p className="text-md text-gray-850 text-center py-10">
            Select a dealer above to manage their module permissions.
          </p>
        )}

        {/* Empty modules */}
        {!loading && selectedDealerId && modules.length === 0 && (
          <p className="font-bold text-md text-center text-gray-950 py-10">
            No access modules found
          </p>
        )}

        {/* Permissions Table */}
        {!loading && selectedDealerId && modules.length > 0 && (
          <>
            <div className="overflow-x-auto rounded-xl border border-black-200 shadow-sm">
              <table className="min-w-full text-sm border border-amber-500">
                <thead>
                  <tr className="bg-amber-500 border-b border-amber-200">
                    <th className="text-left px-4 py-3 font-semibold text-white w-8">
                      #
                    </th>
                    <th className="text-left px-4 py-3 font-semibold text-white">
                      Module Name
                    </th>
                    {PERMISSIONS.map(({ label }) => (
                      <th
                        key={label}
                        className="text-center px-4 py-3 font-semibold text-white"
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {modules.map((module, index) => {
                    const perms = modulePerms[module.access_module_id];
                    if (!perms) return null;

                    const enabled = perms.enabled;
                    return (
                      <tr
                        key={module.access_module_id}
                        className={` transition-colors duration-150
                          ${enabled ? "bg-amber-100 hover:bg-amber-200" : "bg-white hover:bg-amber-200"}`}
                      >
                        <td className="px-4 py-3 text-gray-900 text-xs">
                          {index + 1}
                        </td>
                        <td className="px-4 py-3">
                          <p
                            className={`font-semibold ${enabled ? "text-amber-800" : "text-gray-900"}`}
                          >
                            {module.name || module.access_module_name}
                          </p>
                          {/* <p className="text-xs text-gray-900">{module.alias}</p> */}
                        </td>
                        {/* {PERMISSIONS.map(({ key }) => (
                          <td key={key} className="px-4 py-3 text-center">
                            <CheckBox
                              checked={!!perms[key]}
                              onChange={() => handlePermToggle(module.access_module_id, key)}
                            />
                          </td>
                        ))} */}
                        {PERMISSIONS.map(({ key }) => (
                          <td key={key} className="px-4 py-3 text-center">
                            <CheckBox
                              checked={!!perms[key]}
                              onChange={() =>
                                module.access_module_id !== 10
                                  ? handlePermToggle(
                                      module.access_module_id,
                                      key,
                                    )
                                  : undefined
                              }
                              disabled={module.access_module_id === 10}
                            />
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="mt-6 flex flex-col items-end gap-2">
              {/* {updateSuccess && (
                <p className="text-green-600 text-sm font-semibold">
                  Access modules updated successfully!
                </p>
              )}
              {updateError && (
                <p className="text-red-500 text-sm font-semibold">
                  {typeof updateError === "object"
                    ? updateError.message || JSON.stringify(updateError)
                    : updateError}
                </p>
              )} */}
              <button
                onClick={handleSave}
                disabled={updateLoading || !selectedDealerId}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-6 py-2 rounded-lg text-sm font-semibold shadow-md hover:shadow-lg transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {updateLoading ? "Saving..." : "Save Access"}
              </button>
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default DealerAccessList;
